import axios from "axios";
import { clearProviderSession } from "./utils/session";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_DEVELOPMENT_URL,
  headers: {
    accept: "*/*",
    Authorization:
      (localStorage.getItem("provider__token")
        ? localStorage.getItem("provider__token")
        : sessionStorage.getItem("provider__token")) || "",
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const { response } = error;

    if (response && response.status === 401) {
      clearProviderSession();

      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
